export function renderCreatableSelectFieldActionButtonsTemplate({
  indent,
  fieldName,
  optionsVar,
  searchVar,
  formItemProps,
  labelWithDescription,
  openVar,
  setOpenVar,
  stringify,
  lowerLabel,
  setSearchVar,
  defaultValueFromHandlerContent,
  pendingVar,
  createHandler
}: {
  indent: string
  fieldName: string
  optionsVar: string
  searchVar: string
  formItemProps: string
  labelWithDescription: string
  openVar: string
  setOpenVar: string
  stringify: string
  lowerLabel: string
  setSearchVar: string
  defaultValueFromHandlerContent: string
  pendingVar: string
  createHandler: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => {
${indent}    const selectedOption = ${optionsVar}.find((option) => option.value === formField.value)
${indent}    const createLabel = ${searchVar}.trim()
${indent}    const canCreateOption =
${indent}      createLabel.length > 0 &&
${indent}      !${optionsVar}.some(
${indent}        (option) =>
${indent}          option.label.toLowerCase() === createLabel.toLowerCase() ||
${indent}          option.value.toLowerCase() === createLabel.toLowerCase()
${indent}      )

${indent}    return (
${indent}      <FormItem${formItemProps}>
${indent}        ${labelWithDescription}
${indent}        <Popover open={${openVar}} onOpenChange={${setOpenVar}}>
${indent}          <PopoverTrigger
${indent}            render={
${indent}              <FormControl>
${indent}                <Button
${indent}                type="button"
${indent}                variant="outline"
${indent}                role="combobox"
${indent}                aria-expanded={${openVar}}
${indent}                className={cn("w-full justify-between", {
${indent}                  "text-muted-foreground": !selectedOption
${indent}                })}
${indent}                disabled={isPending}
${indent}                >
${indent}                  <span className="truncate">{selectedOption?.label ?? ${stringify}}</span>
${indent}                  <ChevronsUpDown className="ml-2 size-4 shrink-0 opacity-50" />
${indent}                </Button>
${indent}              </FormControl>
${indent}            }
${indent}          />
${indent}          <PopoverContent className="w-(--anchor-width) p-0" align="start">
${indent}            <Command>
${indent}              <CommandInput
${indent}                placeholder="Search ${lowerLabel}..."
${indent}                value={${searchVar}}
${indent}                onValueChange={${setSearchVar}}
${indent}              />
${indent}              <CommandList>
${indent}                <CommandEmpty>No ${lowerLabel} found.</CommandEmpty>
${indent}                <CommandGroup>
${indent}                  {${optionsVar}.map((option) => (
${indent}                    <CommandItem
${indent}                      key={option.value}
${indent}                      value={\`\${option.label} \${option.value}\`}
${indent}                      onSelect={() => {
${defaultValueFromHandlerContent}${indent}                        formField.onChange(option.value)
${indent}                        ${setSearchVar}('')
${indent}                        ${setOpenVar}(false)
${indent}                      }}
${indent}                    >
${indent}                      <Check className={cn("size-4", {
${indent}                        "opacity-100": formField.value === option.value,
${indent}                        "opacity-0": formField.value !== option.value
${indent}                      })} />
${indent}                      <span className="truncate">{option.label}</span>
${indent}                    </CommandItem>
${indent}                  ))}
${indent}                </CommandGroup>
${indent}              </CommandList>
${indent}              {canCreateOption ? (
${indent}                <>
${indent}                  <CommandSeparator />
${indent}                  <div className="p-1">
${indent}                    <Button
${indent}                      type="button"
${indent}                      variant="ghost"
${indent}                      className="w-full justify-start"
${indent}                      disabled={${pendingVar}}
${indent}                      aria-busy={${pendingVar}}
${indent}                      onClick={() => ${createHandler}(createLabel)}
${indent}                    >
${indent}                      <Plus className="size-4" />
${indent}                      {${pendingVar} ? 'Creating…' : \`Create "\${createLabel}"\`}
${indent}                    </Button>
${indent}                  </div>
${indent}                </>
${indent}              ) : null}
${indent}            </Command>
${indent}          </PopoverContent>
${indent}        </Popover>
${indent}        <FormMessage />
${indent}      </FormItem>
${indent}    )
${indent}  }}
${indent}/>`
}
